module.exports = __webpack_public_path__ + "static/media/05.4d021065.jpg";